"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.candidatesAnswers = exports.candidateAnswerSchema = void 0;
const zod_1 = require("zod");
const answer_schema_1 = require("./answer.schema");
exports.candidateAnswerSchema = answer_schema_1.answerSchema.extend({
    respondent: zod_1.z.enum(["candidate", "expert"]).describe("The respondent must be a candidate or expert.").optional(),
});
exports.candidatesAnswers = zod_1.z.record(zod_1.z.string().uuid(), zod_1.z.array(exports.candidateAnswerSchema)).describe("List of candidates' answers");
